import { render, staticRenderFns } from "./policyDetail.vue?vue&type=template&id=43bbe1d8&scoped=true"
import script from "./policyDetail.vue?vue&type=script&lang=js"
export * from "./policyDetail.vue?vue&type=script&lang=js"
import style0 from "./policyDetail.vue?vue&type=style&index=0&id=43bbe1d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43bbe1d8",
  null
  
)

export default component.exports